import { IconButton } from '@creditornot/cb-button';
import { MoreHorizontal } from '@creditornot/cb-icons';
import { MenuActionItem } from '@creditornot/cb-menu';
import { Popover } from '@creditornot/cb-popover';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { bulkEditItems } from 'apis/restaurant-api/merchant-admin/menu2/api';
import { Category } from 'apis/restaurant-api/merchant-admin/menu2/types';
import { isDefined } from 'common/utils';

import { reportCategoryItemsEnable } from '../behavioral';
import useMenuData from '../useMenuData';

type Props = {
  category: Category;
};

const StyledPopover = styled(Popover).attrs({
  placement: 'bottom-start',
  renderArrow: false,
})`
  display: flex;
  align-items: center;
`;

const ToggleButton = styled(IconButton).attrs({ variant: 'blue', size: 'tiny' })``;

const PopoverContent = styled.div`
  width: 200px;
`;

const PopoverItem = styled(MenuActionItem).attrs({ variant: 'black' })``;

const AllDisabledCategoryActions = ({ category }: Props) => {
  const { items, menu, updateMenuData } = useMenuData();

  if (!menu) {
    throw new Error('Menu not found, this should not happen!');
  }

  const intl = useIntl();

  const [show, setShow] = useState(false);

  const toggle = () => setShow(!show);
  const close = () => setShow(false);

  const handleEnableCategory = async () => {
    const itemsToDisable = category.item_bindings
      .map(itemBinding => items.find(item => item.id === itemBinding.item_id))
      .filter(isDefined)
      .filter(item => item.enabled === false);

    try {
      const updatedMenuContainer = await bulkEditItems(menu.id, {
        item_ids: itemsToDisable.map(i => i.id),
        category_ids: [],
        enabled_flag: true,
      });
      updateMenuData({ actionType: 'updateMenuContainer', payload: updatedMenuContainer });
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'menu.enableCategoryItemsFailureNotification' }), { duration: Infinity });
    }

    reportCategoryItemsEnable();
  };

  return (
    <StyledPopover
      content={
        <PopoverContent>
          <PopoverItem onClick={handleEnableCategory}>
            <FormattedMessage id="menu.enableCategoryItems" />
          </PopoverItem>
        </PopoverContent>
      }
      onClickOutside={close}
      onClickInside={close}
      show={show}
    >
      <ToggleButton onClick={toggle}>
        <MoreHorizontal />
      </ToggleButton>
    </StyledPopover>
  );
};

export default AllDisabledCategoryActions;
